import React from 'react';
import { Chip } from '@mui/material';
import CheckCircleIcon from '@mui/icons-material/CheckCircle';
import CancelIcon from '@mui/icons-material/Cancel';

export const StatusChip = ({ value, trueLabel = 'Yes', falseLabel = 'No' }) => {
  if (value === null || value === undefined) {
    return <Chip size="small" label="Unknown" variant="outlined" />;
  }

  const isPositive = Boolean(value);
  return (
    <Chip
      size="small"
      icon={isPositive ? <CheckCircleIcon /> : <CancelIcon />}
      label={isPositive ? trueLabel : falseLabel}
      color={isPositive ? 'success' : 'default'}
      variant={isPositive ? 'filled' : 'outlined'}
    />
  );
};
